import Buttons from "../../../../components/Button/button.component";
import {
  ButtonContainer,
  HeroLeftContainer,
  SubtitleText,
  SubtitleTextHolder,
  TitleText,
  TitleTextHolder,
  TitleTextHolder2,
} from "./HeroLeft.styles";
import EntranceAnimationY from "../../../../components/EntranceAnimationY";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";
import { useState } from "react";
import ConfettiPage from "../../../../components/ConfettiPage/ConfettiPage.component";
import JoinWailist from "../../../../components/JoinWaitlist/JoinWaitlist.component";
import Button from "../../../../components/Button/Button";

const HeroLeft = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const [showWailist, setShowWaitlist] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);

  const handleJoinWaitList = () => {
    setShowWaitlist(true);
  };

  const handleConfetti = () => {
    setShowWaitlist(false);
    setShowConfetti(true);
  };

  const closeJoinWaitlist = () => {
    setShowWaitlist(false);
  };

  const handleCloseCofetti = () => {
    setShowConfetti(false);
  };
  return (
    <HeroLeftContainer>
      {showWailist ? (
        <JoinWailist
          closeModal={() => setShowWaitlist(false)}
          showCongrats={showConfetti}
          handleClick={handleConfetti}
          handleCloseJoinWaitList={closeJoinWaitlist}
        />
      ) : null}
      {showConfetti === true ? (
        <ConfettiPage handleCloseCofetti={handleCloseCofetti} />
      ) : null}
      <TitleTextHolder>
        <EntranceAnimationY duration={1} delay={1}>
          <TitleText>
            {t("heroSectionText.titleOne", {
              lng: currentLocale,
            })}
          </TitleText>
        </EntranceAnimationY>
      </TitleTextHolder>
      <TitleTextHolder>
        <EntranceAnimationY duration={1} delay={1.3}>
          <TitleText>
            {" "}
            {t("heroSectionText.titleTwo", {
              lng: currentLocale,
            })}
          </TitleText>
        </EntranceAnimationY>
      </TitleTextHolder>
      <TitleTextHolder>
        <EntranceAnimationY duration={1} delay={1.6}>
          <TitleText>
            {t("heroSectionText.titleThree", {
              lng: currentLocale,
            })}
          </TitleText>
        </EntranceAnimationY>
      </TitleTextHolder>

      <TitleTextHolder2>
        <EntranceAnimationY duration={1.5} delay={1}>
          <TitleText>
            {t("heroSectionText.titleOne", {
              lng: currentLocale,
            })}{" "}
            {t("heroSectionText.titleTwo", {
              lng: currentLocale,
            })}{" "}
            {t("heroSectionText.titleThree", {
              lng: currentLocale,
            })}
          </TitleText>
        </EntranceAnimationY>
      </TitleTextHolder2>

      <SubtitleTextHolder>
        <EntranceAnimationY duration={1.5} delay={1.7}>
          <SubtitleText>
            {t("heroSectionText.parapgraphOne", {
              lng: currentLocale,
            })}{" "}
            {t("heroSectionText.parapgraphTwo", {
              lng: currentLocale,
            })}{" "}
            {t("heroSectionText.paragraphThree", {
              lng: currentLocale,
            })}
          </SubtitleText>
        </EntranceAnimationY>
      </SubtitleTextHolder>
      <EntranceAnimationY duration={1.5} delay={2}>
        <ButtonContainer>
          <Button
            id={""}
            type="button"
            disabled={false}
            onClick={handleJoinWaitList}
            padding={"10px 40px"}
            title={t("Join Waitlist", { lng: currentLocale })}
            green
          />
          <Button
            id={""}
            type="button"
            disabled={false}
            onClick={() => {}}
            padding={"10px 40px"}
            title={t("heroSectionText.buttonLabel", { lng: currentLocale })}
            transparent
          />
        </ButtonContainer>
      </EntranceAnimationY>
    </HeroLeftContainer>
  );
};

export default HeroLeft;
